import { experimentFormatContent } from './experiment-format-content'

export function resolveExperimentValues(
  values: Record<string, string>,
  strings: Record<string, string | undefined>,
  translations: Record<string, string>
): Record<string, string> {
  const translated: Record<string, string> = {}

  for (const [placeholder, stringKey] of Object.entries(translations)) {
    const template = strings[stringKey]
    if (template !== undefined) translated[placeholder] = experimentFormatContent(template, values)
  }

  return { ...values, ...translated }
}
